import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IVersione } from "../shared/interfaces";

const controller = "Versioni";

const getVersioni = (aooId: number, protId: number, uorId?: number, cancelToken?: CancelToken): Promise<IVersione[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetVersioni/${protId}`, { params: {uorId}, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getVersioni
}
